import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Header } from '../components/Header'
import { useAlert } from '../contexts/AlertContext'
import { useAuth } from '../hooks/useAuth'
import { vehicleFleetGetAccess } from '../lib/apiPhpAdapter'
import { VehicleFleetAppointPanel } from './vehicle-fleet/VehicleFleetAppointPanel'
import { VehicleFleetCalendarPanel } from './vehicle-fleet/VehicleFleetCalendarPanel'

export default function VehicleFleetAdminView() {
  const navigate = useNavigate()
  const { user } = useAuth()
  const { showAlert } = useAlert()
  const [ready, setReady] = useState(false)

  useEffect(() => {
    let cancelled = false
    vehicleFleetGetAccess()
      .then((a) => {
        if (cancelled) return
        if (!a.canAdmin) {
          navigate('/vehicle-fleet', { replace: true })
          return
        }
        setReady(true)
      })
      .catch(() => {
        if (!cancelled) navigate('/vehicle-fleet', { replace: true })
      })
    return () => {
      cancelled = true
    }
  }, [navigate])

  if (!ready) {
    return (
      <div className="app">
        <Header title="Rezervace vozidel — Admin" />
        <div style={{ padding: '2rem' }}>Načítání…</div>
      </div>
    )
  }

  return (
    <div className="app">
      <Header
        leftButtons={
          <button type="button" className="back-button" onClick={() => navigate('/vehicle-fleet')}>
            ← Zpět na výběr role
          </button>
        }
        title="Rezervace vozidel — Admin"
        rightContent={
          <span style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem' }}>{user?.name}</span>
        }
      />
      <div style={{ padding: '1.25rem 1.5rem', maxWidth: 960, margin: '0 auto', display: 'grid', gap: 16 }}>
        <VehicleFleetAppointPanel
          kind="admins"
          title="Administrátoři autoparku"
          description="Jmenujte uživatele, kteří budou spravovat vozový park a řidiče. Přístup do této sekce má pouze správce IT."
          showAlert={showAlert}
        />
        <VehicleFleetCalendarPanel showAlert={showAlert} canManage canApprove />
      </div>
    </div>
  )
}
